import { useQuery, UseQueryOptions } from 'react-query'

import { AxiosError } from 'axios'
import ApiCall from 'services/ApiCall'

import useUrlQuery, { UseUrlQueryOptions } from 'helpers/QueryUrl/useUrlQuery'

export interface ArticleGetSequences {
  id: number
  name: string
  title: string
  slug: string
  description: string
  listCategory: string
}

type useAllResult = {
  data: any
  result: ArticleGetSequences[]
  total: number
}

type TQueryFnData = useAllResult
type TError = AxiosError

function useGetAllArticle(
  page: number,
  pageSize: number,
  filter?: any,
  type?: any,
  urlOptions?: UseUrlQueryOptions,
  options?: UseQueryOptions<TQueryFnData, TError>,
) {
  const urlQuery = useUrlQuery(urlOptions)
  const queryKey = ['getAllArticle', page, pageSize, filter, type]
  const query = useQuery<TQueryFnData, TError>(
    queryKey,
    () =>
      ApiCall.Article.get(page, pageSize, filter, type).then((res) => {
        return res.data
      }),
    {
      ...options,
      keepPreviousData: true,
    },
  )

  return {
    ...query,
    data: query?.data?.data,
    length: query?.data?.total,
    helpers: urlQuery,
  }
}

export default useGetAllArticle
